









import { Vue, Component, Prop } from 'vue-property-decorator';
import ReadDrdCaptionInterface from './read-drd-caption.interface';

@Component
export default class ReadDrdCaptionItem extends Vue {
  @Prop({ type: Object, required: true })
  caption !: ReadDrdCaptionInterface;

  @Prop({ type: Boolean, default: false })
  dense !: boolean
}
